module.exports = __webpack_public_path__ + "media/images/common/ico_02_sp-f2b6bebefc29aa1c1987a945d4db2ee6.png";